import React, { Component } from 'react'
import Button from 'components/controls/button'
import { inject, addTranslationsLabel, sortAlphabetically } from 'shared/helpers/functional'
import history from 'routes/history'
import { Spinner } from '@blueprintjs/core'

import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';

class ConferenceLink extends Component {
  state = {
    showEditConferenceLinkModal: false,
    realInformationInserted: false,
    emailBody: { __html: '' },
    chosenTranslationsLabels: '',
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.exampleEmail !== this.props.exampleEmail && this.props.templateReceived) {
      let values = {
        meetingInformation: this.state.meetingInformation,
        meetingLink: this.state.editedConferenceLink,
        projectName: this.props.currentProject.name,
        meetingMinutes: this.props.currentProject.interviewLength,
        salesforceJobNumber: this.props.currentProject.salesForceJobNumber,
        firstName: '${firstName}',
        honorarium: '${honorarium}',
        startTime: '${startTime}',
      };
      this.setState({ emailBody: { __html: `${inject(this.props.exampleEmail.__html, values)}` } })
      this.setState({ realInformationInserted: true })
    }
    if (prevState.chosenTranslationsLabels !== this.state.chosenTranslationsLabels) {
      this.props.setChosenTranslationsLabels(this.state.chosenTranslationsLabels)
    }
  }

  copyLinkAction = () => {
    navigator.clipboard.writeText(this.props.currentProject.conferenceLink)
    this.props.showSnackbarMessage("Conference link copied to clipboard.")
    this.props.hideSnackbarMessage()
  }

  // closeEmailTemplate = () => {
  //   this.props.closeTemplate()
  // }


  formatTranslations = (props) => {
    var label = ''
    const sortedArray = this.props.currentProject.chosenTranslations && sortAlphabetically([...this.props.currentProject.chosenTranslations.values()])
    const getLastKeyInArray = sortedArray.slice(-1).pop()
    const displayCondition = props.currentProject.meetingInformationMap.get('en_us') && props.currentProject.meetingInformationMap.get('en_us').replace(/<[^>]+>/g, '').length >0

    if (displayCondition ) {
      sortedArray.map(item => {
        if (this.props.currentProject.meetingInformationMap) {
          label = label + addTranslationsLabel(props.currentProject.defaultLocalizationMap, item.langCode_countryCode, item) + `${item.langCode_countryCode === getLastKeyInArray.langCode_countryCode ? " " : ", "}`
        }
      }
      )
    }
    if (label !== this.state.chosenTranslationsLabels)  {
      this.setState({ chosenTranslationsLabels: label })
    } else if (this.state.chosenTranslationsLabels !== this.props.currentProject.chosenTranslationsLabels) {
      this.props.setChosenTranslationsLabels(this.state.chosenTranslationsLabels)

    }
    return <>
      {(
        props.currentProject.meetingInformationMap &&
        props.currentProject.chosenTranslations.size > 0)
        ? <div>

          {(props.currentProject.meetingInformationMap.get('en_us') &&
            props.currentProject.meetingInformationMap.get('en_us').replace(/<[^>]+>/g, '').replace(/\s/g, '').length !== 0) &&
            <>
              <p className='meeting-information-title'> Meeting Information: </p>
              <span className='meeting-information'></span>
              <td dangerouslySetInnerHTML={{ __html: props.currentProject.meetingInformationMap.get('en_us') }} />
            </>}


          <p className='meeting-information-title'> {props.t('available.languages')} </p> <p> {
            !displayCondition ? props.t('meeting.info.not.required') : label.length > 0 ? label : ''
          }</p>
        </div> :
        <Spinner intent="primary" />
      }
    </>
  }

  render() {
    return (
      <div className="conference-link" key={this.props.currentProject.surveyId}>
        <div className="conference-link-content">
          <div className="link-logo-container">
            <div className="im-link2" />
          </div>
          <div className="conference-link-info">
            <div className="conference-link-name">
              {this.props.t('conference.link.title')}
            </div>
            {!this.props.currentProject.showCopyLinkButton ?
              <div>
                <button className="btn btn-add-link" onClick={() =>
                  history.push(`/projects/${this.props.currentProject.id}/dashboard/conference-link/translations`)
                }>+ add link & translations</button>
                <div>{this.props.t('conference.link.message')}</div>
              </div>
              :
              <div className="conference-link-content-container">
                {this.props.currentProject.conferenceLink && this.props.currentProject.conferenceLink.length > 0 ?
                  <a href={this.props.currentProject.conferenceLink} target="_blank">{this.props.currentProject.conferenceLink}</a>
                  :
                  <span className="no-conference-link-message">No conference link provided</span>
                }
                {this.props.currentProject.chosenTranslations &&
                  <>
                    {this.formatTranslations(this.props)}
                  </>
                }
                <div className="conference-link-footer">
                  <div className="recruiter-controls">
                    <Button
                      className="edit-link btn-primary"
                      onClick={() => history.push(`/projects/${this.props.currentProject.id}/dashboard/conference-link/translations`)}
                    > Edit Link & Translations</Button>
                    {this.props.currentProject.conferenceLink && this.props.currentProject.conferenceLink.length > 0 &&
                      <button
                        title="Copy-Link"
                        className="btn btn-primary"
                        onClick={this.copyLinkAction}
                      > Copy Link
                      </button>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default ConferenceLink
